<section
  class="corte-modalidade-card"
  [class.corte-modalidade-bloqueado]="bloqueado"
  aria-label="Modalidade de venda"
>
  <div class="corte-modalidade-grid">
    <!-- Bloco 1: Venda fracionada (somente informativo) -->
    <div
      class="corte-modalidade-bloco corte-modalidade-bloco--informativo"
      role="group"
      aria-labelledby="corte-mod-fracionado-titulo"
    >
      <div class="corte-modalidade-cabecalho corte-modalidade-cabecalho-estatico">
        <span class="corte-modalidade-textos">
          <span id="corte-mod-fracionado-titulo" class="corte-modalidade-titulo"
            >Venda Fracionada</span
          >
          <span class="corte-modalidade-desc">Medidas disponíveis para venda</span>
        </span>
      </div>

      <div
        class="corte-modalidade-tamanhos"
        role="list"
        aria-label="Medidas disponíveis para venda"
      >
        <span
          *ngFor="let medida of opcoesFracionado"
          class="corte-modalidade-medida-tag"
          role="listitem"
        >
          {{ medida }}m
        </span>
        <span *ngIf="!temFracionado" class="corte-modalidade-medida-vazia">
          Nenhuma medida disponível
        </span>
      </div>
    </div>

    <!-- Bloco 2: Serviço de corte -->
    <div
      class="corte-modalidade-bloco corte-modalidade-bloco--ativo"
      role="group"
      aria-labelledby="corte-mod-servico-titulo"
    >
      <button
        type="button"
        class="corte-modalidade-cabecalho"
        [disabled]="bloqueado"
        [attr.aria-pressed]="true"
        (click)="selecionarModalidade('integral')"
      >
        <span
          class="corte-modalidade-indicador corte-modalidade-indicador--radio"
          [class.corte-modalidade-indicador--ativo]="true"
          aria-hidden="true"
        ></span>
        <span class="corte-modalidade-textos">
          <span id="corte-mod-servico-titulo" class="corte-modalidade-titulo"
            >Tipo de cobrança</span
          >
        </span>
      </button>

      <div
        class="corte-modalidade-tamanhos"
        role="toolbar"
        aria-label="Tipo de cobrança do serviço de corte"
      >
        <button
          *ngFor="let op of opcoesServicoCorte"
          type="button"
          class="corte-modalidade-tamanho-btn"
          [class.corte-modalidade-tamanho-btn--selected]="servicoSelecionado(op.id)"
          [disabled]="bloqueado"
          [attr.aria-pressed]="servicoSelecionado(op.id)"
          [title]="op.hint"
          [attr.aria-label]="op.rotulo + '. ' + op.hint"
          (click)="selecionarServicoCorte(op.id)"
        >
          {{ op.rotulo }}
        </button>
      </div>
    </div>

    <!-- Bloco 3: Resumo / preço / estoque -->
    <div class="corte-modalidade-bloco corte-modalidade-bloco--resumo">
      <p class="corte-modalidade-resumo-label">Serviço de Corte</p>
      <p class="corte-modalidade-preco" aria-live="polite">{{ valorServicoFormatado }}</p>
      <p class="corte-modalidade-selecao-atual">
        <span>{{ rotuloSelecao }}</span>
        <strong>{{ precoServicoFormatado }}</strong>
      </p>

      <div class="corte-modalidade-estoque">
        <div class="corte-modalidade-estoque-cabecalho">
          <span class="corte-modalidade-estoque-label">Utilização do estoque</span>
          <span class="corte-modalidade-estoque-pct">{{ utilizacaoEstoquePct }}%</span>
        </div>
        <div
          class="corte-modalidade-progresso"
          role="progressbar"
          [attr.aria-valuenow]="utilizacaoEstoquePct"
          aria-valuemin="0"
          aria-valuemax="100"
          [attr.aria-label]="'Utilização do estoque: ' + utilizacaoEstoquePct + '%'"
        >
          <div
            class="corte-modalidade-progresso-fill"
            [style.width.%]="utilizacaoEstoquePct"
          ></div>
        </div>
      </div>
    </div>
  </div>
</section>
